import React, { Component } from 'react';
import './tabControl.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';



class TabControl extends Component {
    constructor(props) {
      super(props);
      // PROPS
      // config = [{name:"", isEnable:true/false, show="show/hide", icon="", content:""}]
        this.state = {
            activeTab:this.props.config[0].name,
        };

  }


  // INNER METHOD
  OnClickPrev = () =>{
    var newTab = this.state.activeTab;
    var filteredList = this.props.config.filter(item=>item.isEnable).map(item=>{return item.name});
    filteredList.forEach((tabName,i) => {
      if(tabName === this.state.activeTab){
        if(i===0){
          newTab = filteredList[filteredList.length-1];
        }else{
            newTab = filteredList[i-1];
        }
      }
    });
    this.setState({activeTab:newTab});
  }

  OnClickNext = () =>{
    var newTab = this.state.activeTab;
    var filteredList = this.props.config.filter(item=>item.isEnable).map(item=>{return item.name});
    filteredList.forEach((tabName,i) => {
      if(tabName === this.state.activeTab){
        if(i===filteredList.length-1){
          newTab = filteredList[0];
        }else{
          newTab = filteredList[i+1];
        }
      }
    });
    this.setState({activeTab:newTab});
  }

  OnSwitchTab = (tabName) =>{
    if(this.props.config.filter(item=>item.name===tabName)[0].isEnable){
      this.setState({activeTab:tabName});
    }
    
  }




  // BUILDING METHOD
  createTabsHeader = () =>{
    var tabHeader = null;
    var activeTab = this.state.activeTab;
    var tabs = this.props.config.map((tab,key)=>{
      
      return (
        <div onClick={this.OnSwitchTab.bind(this,tab.name)} key={key} className={activeTab === tab.name? "tab active enable-"+tab.isEnable+" "+tab.show : "tab enable-"+tab.isEnable+" "+tab.show}>
          <div className="iconWrapper">
            <FontAwesomeIcon icon={tab.icon}/>
          </div>
          <div className="tabName">
              {tab.name}
          </div>
        </div>
      )
    });
    tabHeader = <div className="tabHeaderWrapper">{tabs}</div>

    return tabHeader;
  }


  createTabsContent = () =>{
    var tabContent = null;
    var activeTab = this.state.activeTab;
    var contents = this.props.config.map((tab,key)=>{
      return (
        <div key={key} className={activeTab === tab.name? "content active enable-"+tab.isEnable+" "+tab.show : "content enable-"+tab.isEnable+" "+tab.show}>
          {tab.content}
        </div>
      )
    });
    tabContent = <div className="tabContentWrapper">
      <div className="tabContentNav">
        <div className="tabName">{this.state.activeTab}</div>
        <div className="navPrev" onClick={this.OnClickPrev.bind()}><FontAwesomeIcon icon="caret-left"/></div>
        <div className="navNext" onClick={this.OnClickNext.bind()}><FontAwesomeIcon icon="caret-right"/></div>
      </div>
      <div className="tabContentList">
        {contents}
      </div>
    </div>

    return tabContent;
  }
  
  render() {
    var Tabs = this.createTabsHeader();
    var Content = this.createTabsContent();


      return (
          <div className="tabControl" >
            {Tabs}
            {Content}
          </div>
      );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(TabControl);
  